import React, { useEffect } from 'react'
import { Button, Form, Input, Checkbox, message } from 'antd'
//mobx
import { useStore } from '@/store'
import { observer } from 'mobx-react-lite'
import { runInAction, set, toJS } from 'mobx'
import { http } from '@/utils'

const CheckboxGroup = Checkbox.Group

const Configuration = () => {
    //mobx
    //角色
    const { RoleStore } = useStore()
    useEffect(() => {
        RoleStore.setCheckList(toJS(RoleStore.configList))
    }, [RoleStore])
    const checkBoxList = toJS(RoleStore.configList)
    const newCheckList = toJS(RoleStore.newCheckList)
    if (newCheckList.length === 0) {
        checkBoxList = toJS(RoleStore.setCheckList(checkBoxList))
    }
    const onChange = (listIndex, list) => {
        newCheckList.forEach((item, index) => {
            if (listIndex === index) {
                item.checkList = list
            }
            let flag = false
            if (item.hasOwnProperty('checkList') === true && item.checkList.length > 0) {
                flag = true
                newCheckList[index].isChecked = flag
            } else if (item.hasOwnProperty('checkList') === true && item.checkList.length == 0) {
                flag = false
                newCheckList[index].isChecked = flag
            }
        })
        runInAction(() => {
            set(RoleStore, { newCheckList: newCheckList })
        })
    }

    const onCheckAllChange = (index) => {
        newCheckList[index].isChecked = !newCheckList[index].isChecked
        switch (newCheckList[index].isChecked) {
            case false:
                newCheckList[index].checkList = []
                break
            case true:
                switch (newCheckList[index].hasOwnProperty('checkList')) {
                    case true:
                        if (newCheckList[index].checkList.length > 0 && newCheckList[index].checkList.length < newCheckList[index].options.length) {
                            newCheckList[index].checkList = newCheckList[index].options
                        } else if (newCheckList[index].checkList.length > 0 && newCheckList[index].checkList.length == newCheckList[index].options.length) {
                            newCheckList[index].checkList = []
                        } else {
                            newCheckList[index].checkList = newCheckList[index].options
                        }
                        break
                    default:
                        break
                }
                break
            default:
                break

        }
        runInAction(() => {
            set(RoleStore, { newCheckList: newCheckList })
        })
    }

    const onFinish = async () => {
        let rules = ''
        newCheckList.map((item, index) => {
            if (item.isChecked === true) {
                rules = rules + item.id + ','
            }
            if (item.hasOwnProperty('checkList') && item.checkList.length > 0) {
                item.checkList.map((item) => {
                    const findElement = checkBoxList[index].children.find((element) => element.name == item)
                    rules = rules + findElement.id + ','
                })
            }
        })
        rules = rules.substring(0, rules.lastIndexOf(','))
        {
            const res = await http.put(`adminapi/apigroup/${RoleStore.id}`, {
                rules
            })
            if (res.data.code === 200) {
                message.success('添加配置成功')
                runInAction(() => {
                    set(RoleStore, { isOpen: false })
                })
            }

        }
    }
    // 取消按钮
    const [form] = Form.useForm()
    return (
        <>
            <Form
                labelCol={{
                    span: 6,
                }}
                wrapperCol={{
                    span: 14,
                }}
                form={form}
                onFinish={onFinish}
            >
                <Form.Item label="权限选择" >
                </Form.Item>
                <Form.Item wrapperCol={{ offset: 6 }} style={{ width: '86%' }}>
                    {
                        newCheckList.map((item, index) =>
                            <Form.Item key={item.id}>
                                <Checkbox onChange={(() => onCheckAllChange(index))} checked={item.isChecked}>
                                    {item.father}
                                </Checkbox>
                                <CheckboxGroup options={item.options} value={item.checkList} onChange={(checkedValues) => onChange(index, checkedValues)} />
                            </Form.Item>
                        )
                    }
                </Form.Item>
                <Form.Item wrapperCol={{ offset: 6 }}>
                    <Button type="primary" htmlType="submit">
                        确定
                    </Button>
                </Form.Item>
            </Form>
        </>
    )
}

export default observer(Configuration)